import type { ReactNode } from "react"

type StoreCardSectionProps = {
  children: ReactNode
  icon: any
}

export const StoreCardSection = ({ children, icon: Icon }: StoreCardSectionProps) => {
  return (
    <div className="flex flex-row items-center gap-x-3 md:items-start">
      <div className="shrink-0">
        <div className="flex size-8 items-center justify-center rounded-full bg-neutral-200">
          <Icon className="size-5" />
        </div>
      </div>
      <div className="mt-1 md:mt-1.5">{children}</div>
    </div>
  )
}
